import * as React from 'react';

import FeedbackPointsDisplay from 'pages/open-course/peerReview/components/FeedbackPointsDisplay';
import OptionFeedbackRow from 'pages/open-course/peerReview/components/OptionFeedbackRow';
import OptionFeedbackTable from 'pages/open-course/peerReview/components/OptionFeedbackTable';
import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';
import type Review from 'pages/open-course/peerReview/reviewTypes/structured/models/review';
import type reviewsSummaryShape from 'pages/open-course/peerReview/reviewTypes/structured/models/reviewsSummaryShape';
import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/models/schema';

import Content from 'bundles/phoenix/components/Content';

type Props = {
  reviewSchemaPart: InstanceType<typeof ReviewSchemaPart>;
  reviewsSummary: reviewsSummaryShape;
  reviews: InstanceType<typeof Review>[];
  isAssignmentLevelPart: boolean;
  isAIGraded?: boolean;
};

const YesNoDisplayPart = (props: Props) => {
  const { reviewSchemaPart, reviewsSummary, reviews, isAIGraded, isAssignmentLevelPart } = props;

  const choices = ['Yes', 'No'];
  const partId = reviewSchemaPart.get('id');

  const getReviewChoice = (review: $TSFixMe) => review.get('parts').get(partId).get('choice');

  const getReviewsForChoice = (choice: $TSFixMe) => {
    return reviews.filter((review: $TSFixMe) => review.get('parts').get(partId).get('choice') === choice);
  };

  const reviewChoices = reviews.map(getReviewChoice);
  const reviewsSummaryPart = reviewsSummary && reviewsSummary.definition.parts[partId];
  const reviewsSummaryScore = reviewsSummaryPart && reviewsSummaryPart.score;
  const checkedChoice = reviewSchemaPart.getChoiceBestRepresentingReviews(reviewChoices, reviewsSummaryScore);

  const optionRows = choices.map((choice) => {
    const reviewersForChoice: ReviewerDetails[] = getReviewsForChoice(choice).map((review: $TSFixMe) => {
      return {
        fullName: review.get('creator.fullName'),
        isDefaultPhoto: review.get('creator.isDefaultPhoto'),
        isAnonymous: review.get('creator.isAnonymous'),
        photoUrl: review.get('creator.photoUrl'),
      };
    });
    const points = reviewSchemaPart.getChoicePoints(choice);
    const checked = choice === checkedChoice;
    return (
      <OptionFeedbackRow
        reviewers={reviewersForChoice}
        checked={checked}
        groupId={partId}
        optionId={choice}
        key={choice}
        isAIGraded={isAIGraded}
        isAssignmentLevelPart={isAssignmentLevelPart}
      >
        {reviewSchemaPart.get('points') && (
          <div>
            <FeedbackPointsDisplay
              actualPoints={checked ? reviewsSummaryScore : undefined}
              points={points}
              checked={checked}
            />
          </div>
        )}
        {choice}
      </OptionFeedbackRow>
    );
  });

  return (
    <div className="rc-YesNoDisplayPart">
      <Content content={reviewSchemaPart.get('prompt')} />
      <OptionFeedbackTable>{optionRows}</OptionFeedbackTable>
    </div>
  );
};

export default YesNoDisplayPart;
